import React from "react";
import { FaFileAlt, FaNetworkWired, FaLightbulb, FaMoneyBillWave, FaBullhorn, FaHandsHelping } from "react-icons/fa";

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6 process-two-single">
      <div className="services-style-two-item fade-up-anim">
        <div className="top-info">
          <div className="icon" style={{ fontSize: "40px", color: "#007bff" }}>
            <Icon />
          </div>
          <h4><a>{title}</a></h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

function Comprehensive() {
  const features = [
    { title: "Comprehensive Documentation Support", description: "Expert assistance in preparing required legal, technical, and financial documents to meet exchange requirements and compliance standards.", icon: FaFileAlt },
    { title: "Exchange Network Access", description: "Leveraging established relationships with top exchanges, Xeer Technology helps projects secure listings on platforms best suited to their goals, whether high-liquidity CEXs or popular DEXs.", icon: FaNetworkWired },
    { title: "Listing Strategy Development", description: "Crafting a listing strategy tailored to maximize token exposure, ensure liquidity, and align with long-term project goals.", icon: FaLightbulb },
    { title: "Token Liquidity Solutions", description: "Market-making services to enhance token liquidity post-listing, facilitating a stable trading environment that attracts new traders and investors.", icon: FaMoneyBillWave },
    { title: "Marketing & Promotion", description: "Providing listing promotion services, including press releases, social media, and targeted campaigns to maximize reach and engagement.", icon: FaBullhorn },
    { title: "Post-Listing Support", description: "Continuous monitoring and reporting services to track token performance, manage liquidity, and optimize token price stability over time.", icon: FaHandsHelping },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                Key Features of our Exchange Listing Service
              </h2>
            </div>
          </div>
        </div>
        <div className="container fade-up-anim">
          <div className="row">
            {features.map((feature, idx) => (
              <FeatureCard key={idx} {...feature} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Comprehensive;